module.exports = __webpack_public_path__ + "img/icons8-gmail.91f84717.svg";